import * as React from 'react';
import * as CSSTransition from 'react-transition-group/CSSTransition';
import {css, keyframes} from 'emotion';

const notificationFadeIn = keyframes`
  0% {
    opacity: 0;
    left: 384px;
  }
  100% {
    left: 0;
    opacity: 1;
  }
`;

const notificationFadeOut = keyframes`
 0% {
    opacity: 1;
    margin-bottom: 16px;
    padding-top: 16px;
    padding-bottom: 16px;
    max-height: 150px;
  }
  100% {
    opacity: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
    max-height: 0;
  }
`;

const styles = {
  enter: css`
    opacity: 0;
    animation-duration: 0.24s;
    animation-fill-mode: both;
    animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
    animation-play-state: paused;
  `,

  exit: css`
    animation-duration: 0.2s;
    animation-fill-mode: both;
    animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
    animation-play-state: paused;
  `,

  enterActive: css`
    animation-name: ${notificationFadeIn};
    animation-play-state: running;
  `,

  exitActive: css`
    animation-name: ${notificationFadeOut};
    animation-play-state: running;
  `
};

export default class NotificationFade extends React.Component {
  public render() {
    return <CSSTransition {...this.props} classNames={styles} timeout={{enter: 240, exit: 200}} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Notifications/private/NotificationFade.tsx